import { MoralisProvider } from "react-moralis";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import { Footer, Navbar } from "./components";
import Create from "./pages/Create";
import Finish from "./pages/Finish";
import Home from "./pages/Home";
import Ido from "./pages/Ido";

function App() {
  return (
    <MoralisProvider appId={process.env.REACT_APP_APPID} serverUrl={process.env.REACT_APP_SERVER_URL}>
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<Create />} />
          <Route path="/finish" element={<Finish />} />
          <Route path="/private/:address" element={<Ido />} />
          <Route path="/public/:address" element={<Ido />} />
        </Routes>
        <Footer />
      </div>
    </MoralisProvider>
  );
}

export default App;
